const apiBase = "";
// const tunnelApiBase = "https://myapi-33dvsn7xmq-ew.a.run.app";
// const tunnelApiBase = "http://127.0.0.1:80";

const tunnelApiBase = process.env.REACT_APP_API_URL;

export { apiBase, tunnelApiBase };
